<template>
    <div class="sw-grid-flex sw-grid-flex--dir-column" ref="pricingTiers">
        <div v-for="(tier, i) in tierDisplayOrder" :key="'pricing-tier-' + (i + 1)" :id="'pricing-tier-' + (i + 1)" class="card-wrapper">
            <b-card
                :title="'Tier ' + tier.tier + tierStatus(tier.pricingModelId, tier.tier)"
                :class="{'removed-tier': removedTiers.includes(tier.pricingModelId),
                    'error-tier': rangeOverlaps.includes(tier.tier) || rangeGaps.includes(tier.tier),
                    'new-tier': tier.pricingModelId === 0}"
            >
                <div class="form-section">
                    <div>
                        <select class="sw-select--not-round sw--width-half">
                            <option :value="0">No</option>
                            <option :value="1">Yes</option>
                        </select>
                    </div>
                    <div v-for="(item, index) in tier.inputs" :key="'pricing-input-' + index"
                         class="sw-grid-flex__cell-1-4 sw--padding-2"
                         :class="removedTiers.includes(tier.pricingModelId) ? 'sw-dms--color-grey-64' : ''">
                        <h6>{{ item.text }}</h6>
                        <input type="number" step="0.0001" min="0"
                               onfocus="this.previousValue = this.value"
                               onkeydown="this.previousValue = this.value"
                               oninput="(validity.valid || this.value === '') || (value = this.previousValue)"
                               class="sw--input-height__medium sw--font-size-14 sw--width-full"
                               :style="!materialId || removedTiers.includes(tier.pricingModelId) ? 'color: #c7cdd0;' : ''"
                               required
                               :disabled="!materialId || removedTiers.includes(tier.pricingModelId)"
                               v-model.number="item.value">
                    </div>
                </div>

                <b-button v-if="tierInputs.length > 1 && tier.pricingModelId !== 0" class="card-btn" variant="primary" @click="removeTier(tier.pricingModelId)">
                    <span v-if="!removedTiers.includes(tier.pricingModelId)">Remove</span>
                    <span v-else>Undo</span>
                </b-button>
                <b-button v-else-if="tierInputs.length > 1" class="card-btn" variant="primary" @click="removeNewTier(tier.tier)">
                    <span>Remove</span>
                </b-button>
            </b-card>
        </div>

        <div v-if="showErrorModal" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <h3>Please fix issues with tier ranges</h3>
                    </div>

                    <div class="modal-body">
                        <div v-if="rangeGaps.length">
                            <h6>Range Gaps in following tiers</h6>
                            <ul>
                                <li v-for="tier in rangeGaps">{{ tier }}</li>
                            </ul>
                        </div>
                        <hr>
                        <div v-if="rangeOverlaps.length">
                            <h6>Range Overlaps in following tiers</h6>
                            <ul>
                                <li v-for="tier in rangeOverlaps">{{ tier }}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div name="footer">
                            <div style="display: inline-flex; justify-content: center; width: 100%;">
                                <div class='cancel action-button' @click="showErrorModal = false">Cancel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bottom-banner
            :missing-info="!materialId ? ['Basic Information'] : []"
            v-on:saved="updateSubmissionData"
            v-on:add-new="addNewTier"
            :show-saved-message="showSavedMessage"
            :show-add-new-btn="showAddNewBtn"/>
    </div>
</template>

<script>

    import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
    import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
    import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner";

    export default {
        name: "material-pricing",
        components: {BottomBanner},
        mixins: [VueJQueryMixin, VueSwMixin],
        props: {
            materialId: {
                type: Number,
                required: false
            },
            currentMaterial: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            showSavedMessage: false,
            showAddNewTier: false,
            showAddNewBtn: true,
            showErrorModal: false,
            rangeGaps: [],
            rangeOverlaps: [],
            tierInputs: [],
            removedTiers: [],
        }),
        created() {
            if (this.currentMaterial) {
                if (this.currentMaterial.pricingTiers.length !== 0) {
                    this.currentMaterial.pricingTiers.forEach((tier) => {
                        this.tierInputs.push({
                            pricingModelId: tier.pricingModelId,
                            tier: tier.tier,
                            inputs: [
                                {name: 'maxAxisGreater', text: 'Max Axis Greater', value: tier.maxAxisGreater},
                                {name: 'maxAxisLess', text: 'Max Axis Less', value: tier.maxAxisLess},
                                {name: 'minimumPrice', text: 'Minimum Price', value: tier.minimumPrice},
                                {name: 'minimumPriceModel', text: 'Minimum Price Model', value: tier.minimumPriceModel},
                                {name: 'basePrice', text: 'Base Price', value: tier.basePrice},
                                {name: 'ratePerPart', text: 'Rate Per Part', value: tier.ratePerPart},
                                {name: 'rateBboxVolume', text: 'Rate Bbox Parts Volume', value: tier.rateBboxPartsVolume},
                                {name: 'materialVolumeCC', text: 'Material Volume CC', value: tier.materialVolumeCc},
                                {name: 'machineVolumeCC', text: 'Machine Volume CC', value: tier.machineVolumeCc},
                                {name: 'bbCC', text: 'Bounding Box CC', value: tier.boundingBoxCc},
                                {name: 'fudSupportCC', text: 'FUD Support CC', value: tier.fudSupportCc},
                                {name: 'fudSupportMachineCC', text: 'FUD Support Machine CC', value: tier.fudSupportMachineCc},
                                {name: 'surfaceAreaCm2', text: 'Surface Area Cm2', value: tier.surfaceAreaCm2}
                            ]
                        })
                    })
                } else {
                    this.addNewTier();
                }
            } else {
                this.addNewTier();
            }
        },
        methods: {
            removeTier(pricingModelId) {
                if(!this.removedTiers.includes(pricingModelId)) {
                    this.removedTiers.push(pricingModelId);
                } else {
                    let i = this.removedTiers.indexOf(pricingModelId);
                    this.removedTiers.splice(i, 1);
                }
            },
            removeNewTier(tier) {
                let i = this.tierInputs.indexOf(tier);
                this.tierInputs.splice(i, 1);
            },
            showAddNew() {
                this.showAddNewTier = true;
                this.showAddNewBtn = false;
            },
            addNewTier() {
                let newTier = this.tierInputs.length + 1;
                this.tierInputs.push({
                    pricingModelId: 0,
                    tier: newTier,
                    inputs: [
                        {name: 'maxAxisGreater', text: 'Max Axis Greater', value: 0},
                        {name: 'maxAxisLess', text: 'Max Axis Less', value: 0},
                        {name: 'minimumPrice', text: 'Minimum Price', value: 0},
                        {name: 'minimumPriceModel', text: 'Minimum Price Model', value: 0},
                        {name: 'basePrice', text: 'Base Price', value: 0},
                        {name: 'ratePerPart', text: 'Rate Per Part', value: 0},
                        {name: 'rateBboxVolume', text: 'Rate Bbox Parts Volume', value: 0},
                        {name: 'materialVolumeCC', text: 'Material Volume CC', value: 0},
                        {name: 'machineVolumeCC', text: 'Machine Volume CC', value: 0},
                        {name: 'bbCC', text: 'Bounding Box CC', value: 0},
                        {name: 'fudSupportCC', text: 'FUD Support CC', value: 0},
                        {name: 'fudSupportMachineCC', text: 'FUD Support Machine CC', value: 0},
                        {name: 'surfaceAreaCm2', text: 'Surface Area Cm2', value: 0}
                    ]
                })
                setTimeout(function() {
                    let newElement = document.getElementById('pricing-tier-' + newTier);
                    window.scroll({ top: newElement.offsetTop, behavior: "smooth" });
                }, 100);
            },
            tierStatus(pricingModelId, tier) {
                if (this.removedTiers.includes(pricingModelId)) {
                    return ' (removed)'
                } else if (this.rangeOverlaps.includes(tier) || this.rangeGaps.includes(tier)) {
                    return ' (error)'
                } else if (pricingModelId === 0) {
                    return ' (new)'
                }

                return ''
            },
            updateSubmissionData() {
                let _this = this;
                let parsedTierInputs = [..._this.tierInputs];

                parsedTierInputs = parsedTierInputs.filter(ar => !_this.removedTiers.find(rm => (rm === ar.pricingModelId) ))

                parsedTierInputs.sort((a, b) => Number(a.inputs[0].value) - Number(b.inputs[0].value));

                for (var i=1; i < parsedTierInputs.length; i++) {
                    let startOfGap = parsedTierInputs[i-1].inputs[1].value;
                    let endOfGap = parsedTierInputs[i].inputs[0].value;

                    if (startOfGap < endOfGap) {
                        if (!_this.rangeGaps.includes(parsedTierInputs[i].tier)) {
                            _this.rangeGaps.push(parsedTierInputs[i].tier);
                        }
                    } else if (_this.rangeGaps.includes(parsedTierInputs[i].tier)) {
                        let index = _this.rangeGaps.indexOf(parsedTierInputs[i].tier);
                        _this.rangeGaps.splice(index, 1);
                    }

                    if (endOfGap < startOfGap) {
                        if (!_this.rangeOverlaps.includes(parsedTierInputs[i].tier)) {
                            _this.rangeOverlaps.push(parsedTierInputs[i].tier);
                        }
                    } else if (_this.rangeOverlaps.includes(parsedTierInputs[i].tier)) {
                        let index = _this.rangeOverlaps.indexOf(parsedTierInputs[i].tier);
                        _this.rangeOverlaps.splice(index, 1);
                    }
                }

                parsedTierInputs.forEach((tier) => {
                    if (tier.inputs[0].value > tier.inputs[1].value) {
                        if (!_this.rangeOverlaps.includes(tier.tier)) {
                            _this.rangeOverlaps.push(tier.tier);
                        }
                    } else if (_this.rangeOverlaps.includes(tier.tier)) {
                        let index = _this.rangeOverlaps.indexOf(tier.tier);
                        _this.rangeOverlaps.splice(index, 1);
                    }
                });

                if (this.rangeGaps.length || this.rangeOverlaps.length) {
                    this.showErrorModal = true;
                } else {
                    parsedTierInputs.forEach((tier, index) => {
                        tier.tier = index + 1;
                    });
                    this.saveMaterialPrice(parsedTierInputs);
                }
            },
            saveMaterialPrice(parsedTierInputs) {
                let data = {};
                data['materialId'] = this.materialId;
                data['removedTiers'] = this.removedTiers;
                data['pricingTiers'] = [];
                parsedTierInputs.forEach(tier => {
                    let tierInputs = {}
                    tier.inputs.forEach(input => {
                        tierInputs[input.name] = input.value
                    })
                    data['pricingTiers'].push({
                        'tier': tier.tier,
                        'pricingModelId': tier.pricingModelId,
                        'inputs': tierInputs
                    });
                })
                let _this = this;
                this.$jQuery.ajax({
                    type: 'POST',
                    url: '/admin/material/' + _this.materialId + '/price',
                    dataType: 'json',
                    data: data,
                    success: (data) => {
                        _this.$emit('success', data);
                        _this.showSavedMessage = true;
                        this.$sw.notifications.success('Saved!')

                        let updatedPricingTiers = data.pricingTiers[_this.materialId];

                        this.removedTiers = [];
                        this.tierInputs = [];
                        Object.keys(updatedPricingTiers).forEach((key) => {
                            let tier = updatedPricingTiers[key];
                            this.tierInputs.push({
                                pricingModelId: tier.pricingModelId,
                                tier: tier.tier,
                                inputs: [
                                    {name: 'maxAxisGreater', text: 'Max Axis Greater', value: tier.maxAxisGreater},
                                    {name: 'maxAxisLess', text: 'Max Axis Less', value: tier.maxAxisLess},
                                    {name: 'minimumPrice', text: 'Minimum Price', value: tier.minimumPrice},
                                    {name: 'minimumPriceModel', text: 'Minimum Price Model', value: tier.minimumPriceModel},
                                    {name: 'basePrice', text: 'Base Price', value: tier.basePrice},
                                    {name: 'ratePerPart', text: 'Rate Per Part', value: tier.ratePerPart},
                                    {name: 'rateBboxVolume', text: 'Rate Bbox Parts Volume', value: tier.rateBboxPartsVolume},
                                    {name: 'materialVolumeCC', text: 'Material Volume CC', value: tier.materialVolumeCc},
                                    {name: 'machineVolumeCC', text: 'Machine Volume CC', value: tier.machineVolumeCc},
                                    {name: 'bbCC', text: 'Bounding Box CC', value: tier.boundingBoxCc},
                                    {name: 'fudSupportCC', text: 'FUD Support CC', value: tier.fudSupportCc},
                                    {name: 'fudSupportMachineCC', text: 'FUD Support Machine CC', value: tier.fudSupportMachineCc},
                                    {name: 'surfaceAreaCm2', text: 'Surface Area Cm2', value: tier.surfaceAreaCm2}
                                ]
                            })
                        })
                    },
                    error: (jqXHR) => {
                        const responseString = JSON.stringify(jqXHR.responseText);
                        const response = JSON.parse(responseString);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });
            },
        },
        computed: {
            tierDisplayOrder() {
                return this.tierInputs.sort((a, b) => Number(a.tier) - Number(b.tier))
            }
        }
    }
</script>

<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 60%;
    min-width: 400px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
}

.modal-header h3 {
    margin-top: 0;
    color: red;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

hr {
    margin: 17px 0;
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
    padding: 10px;
}

.card-title {
    margin-left: 10px;
    margin-top: 10px;
}

.card-btn {
    margin-left: 10px;
    margin-bottom: 10px;
}

.card-wrapper:not(:first-child) {
    margin-top: 12px;
}

.form-section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.btn {
    margin-top: 10px;
}

.removed-tier {
    background-color: #c7cdd0;
}

.new-tier {
    background-color: rgba(19, 153, 171, 0.93);
}

.error-tier {
    background-color: rgba(171, 19, 35, 0.93);
}
</style>

